import React, { Children, useCallback, useEffect, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import styles from './Modal.module.scss';
import modalExit from '../../../assets/icons/vector/exitModalIcon.svg';
import { useNavigate } from 'react-router-dom';
import Portal from '../Portal/Portal';
import Button from 'component/atom/forms/button/Button';
import { useBrandingContext } from 'app-context/BrandingsContext';
import SvgWithBranding from '../branding/withBrandingColor.hoc';

const Modal = ({
  isOpen,
  onClose,
  title,
  modalContent, //component:form ,
  onSubmit, //component-form ->onSubmit
  route,
  onSubmitstyles, // {labe,type,variant,opicBackground} for button
  isLoading,
  classname,
  children,
  isHtml,
  showCancel = true,
  exitComponent,
  footerComponent,
  contentClassName,
  cancelClassName,
  cancelVariant = 'dark',
  disabledFooter,
}) => {
  const navigate = useNavigate();
  const nodeRef = useRef(null);

  const { brandingData } = useBrandingContext();
  const { page_TextColor } = brandingData;

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isOpen]);

  const handleClose = useCallback(() => {
    if (onClose) onClose();
  }, [onClose]);

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit();
    }
    if (route) {
      document.body.style.overflow = 'auto';
      navigate(route);
    }
    // handleClose();
  };
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        handleClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, handleClose]);
  return (
    <Portal>
      <CSSTransition
        in={isOpen}
        timeout={150}
        classNames={{
          enter: styles['fade-enter'],
          enterActive: styles['fade-enter-active'],
          exit: styles['fade-exit'],
          exitActive: styles['fade-exit-active'],
        }}
        unmountOnExit
        nodeRef={nodeRef}
      >
        <div
          className={styles['modal-overlay']}
          style={{
            color: page_TextColor,
          }}
        >
          <div
            ref={nodeRef}
            className={`${styles['modal-content']} ${classname || ''}`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={styles['title-container']}>
              <p className={styles['page-title']}>{title}</p>
              <div className={styles['exit-container']}>
                {exitComponent ? exitComponent : null}
                <SvgWithBranding
                  type='exit_modal'
                  onClick={handleClose}
                  className={styles['exit-img']}
                />
              </div>
            </div>
            <div className={styles.horizantalLine}></div>
            {modalContent?.subtitle && (
              <div className={styles['sub-title']}>
                {modalContent?.subtitle ? (
                  <p>{modalContent?.subtitle}</p>
                ) : null}
              </div>
            )}

            <div className={`${styles.content} ${contentClassName}`}>
              {modalContent?.component}
              {isHtml ? (
                <div dangerouslySetInnerHTML={{ __html: children }} />
              ) : (
                children
              )}
            </div>
            {modalContent?.component ? (
              <div className={styles.footer}>
                <div> {footerComponent ?? null}</div>
                <div className={styles['actions']}>
                  {showCancel && (
                    <Button
                      onClick={handleClose}
                      label='Cancel'
                      variant={cancelVariant}
                      className={cancelClassName}
                    />
                  )}
                  <Button
                    onClick={handleSubmit}
                    label={onSubmitstyles?.onSubmit.label || 'Submit'}
                    type={onSubmitstyles?.onSubmit.type} //svg type
                    isLoading={isLoading}
                    variant={onSubmitstyles?.onSubmit.variant}
                    opicBackground={onSubmitstyles?.onSubmit.opicBackground}
                    disabled={disabledFooter || isLoading}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </CSSTransition>
    </Portal>
  );
};

export default Modal;
